import React, {Component} from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { IsEmpty, returnFirstTier, seriesHeader } from "../../util/commonFunctions";
import { getEventsList, logout, setSignupModalStatus } from "../../actions";
import cosmeticConfig from "../../../config/cosmeticConfig";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.handleEscKey = this.handleEscKey.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleEscKey, false);
    if (!this.props.upcoming_events && !this.props.previous_events) {
			this.props.getEventsList("all");
		}
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleEscKey, false);
  }

  handleEscKey(event) {
    if (event.keyCode === 27) this.closeModal();
  }

  logout = event => {
    this.props.onLogout();
    this.props.closeModal();
    this.props.history.push("/");
  };

  openSigninModalPopup = (formName) => {
    this.props.setSignupModalStatus(true, formName);
  };

  closeModal = (event = null) => {
    if (event) {
      event.stopPropagation();
    }
    this.enableScroll();
    this.props.closeModal();
  };

  enableScroll = (e) => {
    document.getElementsByTagName("body")[0].classList.remove("modal-open");
    document.getElementsByTagName("body")[0].style.overflow = "visible";
  };

  toggleActiveOnClick = event => {
    event.preventDefault();
    const elem = event.target.closest("li").classList.contains("active");
    event.target
      .closest("li")
      .parentElement.querySelectorAll(".active")
      .forEach(event => event.classList.remove("active"));

    if (elem) {
      event.target.closest("li").classList.remove("active");
    } else {
      event.target.closest("li").classList.add("active");
    }
  };

  toggleActiveSeriesOnClick = (event) => {
    event.preventDefault();
    if (window.screen.width < 1024) {
      const elem = event.target.closest("li").classList.contains("active");
      event.target
        .closest("li")
        .parentElement.querySelectorAll(".active")
        .forEach(event => event.classList.remove("active"));

      if (elem) {
        event.target.closest("li").classList.remove("active");
      } else {
        event.target.closest("li").classList.add("active");
      }
    }
  };

  render() {
    return (
      <div className="outer-nav-wrapper">
        <div id="vertical-bar">
          <img
            className="cross"
            src="/assets/svg/cross.svg"
            onClick={() => this.closeModal()}
          />
          <ul>
            {!IsEmpty(this.props.userProfile) ? null : (
              <li>
                <a
                  href="javascript:void(null);"
                  className="vertical-menu d-flex align-items-center displayMobile"
                  onClick={() => this.openSigninModalPopup("signin")}
                >
                  <img
                    className="avatar"
                    src="/assets/svg/profile-active.svg"
                  />
                  Sign in
                </a>
              </li>
            )}
            <li>
              <Link
                to="/search"
                className="vertical-menu d-flex align-items-center displayMobile"
              >
                <img className="search" src="/assets/svg/search.svg" />
                Search
              </Link>
            </li>
            <li>
              <Link to="/" className="vertical-menu" onClick={() => this.closeModal()}>
                Home
              </Link>
            </li>
            <li >
              <Link to="/for-you" className="vertical-menu" onClick={() => this.closeModal()}>For You</Link>
            </li>
            {
              !IsEmpty(this.props.userProfile) &&
              <li >
                <Link to="/follow-management" className="vertical-menu" onClick={() => this.closeModal()}>Watchlist</Link>
              </li>
            }
            <li className="vertical-menu-head">Discover</li>
            {!this.props.isListLoading && (this.props.upcoming_events && this.props.upcoming_events.length > 0 || this.props.previous_events && this.props.previous_events.length > 0) &&
              <li>
                <a className="vertical-menu" href="/all-events">
                  Events
                </a>
              </li>
            }
            {this.props.nodeSeries && !IsEmpty(this.props.nodeSeries) &&
              <li>
                <div className="verticalDiv">
                  <span className="aus" onClick={this.toggleActiveSeriesOnClick}>
                    <a href="#" className="vertical-menu">
                      Series
                    </a>
                  </span>
                  <ul className="sub-menu">
                    {
                      seriesHeader(
                        this.props.nodeSeries,
                        cosmeticConfig.menu_vertical.MAX_IN_A_ROW,
                        this
                      )
                    }
                  </ul>
                </div>
              </li>
            }

            {!IsEmpty(this.props.nodeTier) &&
              returnFirstTier(
                this.props.nodeTier.slice(0, 4),
                cosmeticConfig.menu_vertical.MAX_IN_A_ROW,
                "",
                "vertical-menu",
                "sub-menu",
                this.toggleActiveOnClick,
                "",
                "",
                this
              )}
            <li>
              <div className="verticalDiv">
                <a
                  href="#"
                  className="vertical-menu"
                  onTouchStart={event => this.toggleActiveOnClick(event)}
                >
                  Podcasts
                </a>
                <ul className="sub-menu">
                  <ul>
                    <li className="vertical-menu">
                      <a
                        href="https://play.acast.com/s/the-call"
                        target="_blank"
                      >
                        The Call
                      </a>
                    </li>
                    <li className="vertical-menu">
                      <a
                        href="https://play.acast.com/s/the-cob"
                        target="_blank"
                      >
                        The COB
                      </a>
                    </li>
                  </ul>
                </ul>
              </div>
            </li>
            <li className="vertical-menu-head">Company</li>
            <li>
              <div className="verticalDiv">
                <a
                  href="#"
                  className="vertical-menu"
                  onTouchStart={event => this.toggleActiveOnClick(event)}
                >
                  Legal
                </a>
                <ul className="sub-menu">
                  <ul>
                    <li>
                      <a href="https://company.ausbiz.com.au/privacy-policy" target="_blank">
                        Privacy policy
                      </a>
                    </li>
                    <li>
                      <a href="https://company.ausbiz.com.au/terms-of-service" target="_blank">
                        Terms of Service
                      </a>
                    </li>
                  </ul>
                </ul>
              </div>
            </li>
            <li>
              <a
                href="https://company.ausbiz.com.au/contact"
                target="_blank"
                className="vertical-menu"
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                href="https://company.ausbiz.com.au/"
                className="vertical-menu"
                target="_blank"
              >
                About
              </a>
            </li>
            <li>
              <a href="https://company.ausbiz.com.au/faq-tcs" className="vertical-menu" target="_blank">
                FAQ
              </a>
            </li>

            {!IsEmpty(this.props.userProfile) && (
              <React.Fragment>
                <li className="vertical-menu-head displayMobile">ACCOUNT</li>
                <li className="displayMobile">
                  <div className="verticalDiv">
                    <a
                      href="#"
                      className="vertical-menu"
                      onTouchStart={event => this.toggleActiveOnClick(event)}
                    >
                      My Profile
                    </a>
                    <ul className="sub-menu">
                      <ul>
                        <li className="vertical-menu">
                          <Link to="/profile/personal">Personal</Link>
                        </li>
                        {(this.props.userProfile.provider &&
                          this.props.userProfile.provider.toLowerCase() === "linkedin") ||
                          (this.props.userProfile.provider &&
                            this.props.userProfile.provider.toLowerCase() === "apple") ||
                          (this.props.userProfile.provider &&
                            this.props.userProfile.provider.toLowerCase() === "google") ? null : (
                          <li className="vertical-menu">
                            <Link to="/profile/security">Security</Link>
                          </li>
                        )}
                        <li className="vertical-menu">
                          <Link to="/profile/privacy">Data-Privacy</Link>
                        </li>
                      </ul>
                    </ul>
                  </div>
                </li>
                <li className="displayMobile">
                  <span
                    className="vertical-menu"
                    onClick={event => this.logout(event)}
                  >
                    Sign out
                  </span>
                </li>
              </React.Fragment>
            )}

            <li>
              <ul className="d-flex flex-row align-items-center social-icons">
                <li>
                  <a
                    href="https://apps.apple.com/us/app/apple-store/id1494428911"
                    target="_blank"
                  >
                    <img
                      src="/assets/svg/app-store.svg"
                      alt="Apple App Image"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/ausbiztv"
                    target="_blank"
                    className="twitter"
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/711458752615326"
                    className="facebook"
                    target="_blank"
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/ausbiztv"
                    className="linkedin"
                    target="_blank"
                  ></a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userProfile: state.auth.userProfile,
    upcoming_events: state.eventDetails.upcoming_events,
    previous_events: state.eventDetails.previous_events,
    isListLoading:  state.eventDetails.isListLoading,
  };
};

function mapDispatchToProps(dispatch){
  return {
    onLogout: () => dispatch(logout()),
    getEventsList: () => dispatch(getEventsList("all")),
    setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Menu));
